import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { PersonReportItem } from 'src/modules/serasa/serasa.experian.person.types'
import { formatDateNoTz } from 'src/utils/formatter-utils'

export type ContatosProps = {
    person: PersonReportItem
}

export default function Contatos({ person }: ContatosProps) {
    if (!person.registration.phones) {
        return <></>
    }

    return (
        <>
            <Divider textAlign="center">Contatos</Divider>

            {person.registration.phones.map((phone, index) => (
                <Grid key={index} container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                    <GridItem
                        label="Data Atualização"
                        value={phone.updateDate ? formatDateNoTz(phone.updateDate) : '-'}
                        xs={12}
                    />
                    <GridItem
                        label="Número"
                        value={`+${phone.regionCode} (${phone.areaCode}) ${phone.phoneNumber}`}
                        xs={3}
                    />
                    <GridItem label="Tipo" value={phone.phoneType || '-'} xs={3} />
                </Grid>
            ))}
        </>
    )
}
